module.exports = __webpack_public_path__ + "img/lf5.7af4193d.png";